import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IToaster } from '@seb/web-design-system/core';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private toasterSubject = new Subject<IToaster>();

  constructor(private translateService: TranslateService) {}

  public get toasterSubject$(): Observable<IToaster> {
    return this.toasterSubject.asObservable();
  }

  public sendToasterEvent(toaster: IToaster): void {
    toaster.title = this.translateService.instant(toaster.title);

    if (Array.isArray(toaster.description)) {
      toaster.description = toaster.description
        .map((desc) => this.translateIfKey(desc))
        .join(', ');
    } else {
      toaster.description = this.translateIfKey(toaster.description);
    }

    this.toasterSubject.next(toaster);
  }

  public sendToasterEventNoTranslate(toaster: IToaster) {
    this.toasterSubject.next(toaster);
  }

  private translateIfKey(value: string): string {
    if (!value || typeof value !== 'string') return '';

    const translation = this.translateService.instant(value);

    return translation !== value ? translation : value;
  }
}
